/**
 * What the two admin sign-in screens share: where the second one lives, what the first
 * one hands it, and how an API failure becomes something an editor can read.
 */

import { ApiError } from "~/lib/api";

/** The one-time-code step is a route so browser history supplies the back behaviour. */
export const AUTH_CODE_PATH = "/auth/code";

/**
 * Router state deliberately owns these short-lived values. Reloading drops the state
 * and returns to the e-mail step instead of presenting a code form without a request.
 */
export interface CodeStepState {
  email: string;
  expiresIn: number;
  /** Only ever set when the API runs with OTP echo on, which production forbids. */
  debugCode: string | null;
}

/**
 * Return an i18n key rather than a message so changing language also retranslates an
 * error that is already on screen.
 */
export function translateAuthError(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 429) return "auth.errors.rateLimited";
    if (error.status === 401) return "auth.errors.invalidCode";
    if (error.status === 403) return "auth.errors.inactiveAccount";
    // The API rejects more addresses than the client regex (reserved domains among
    // them), which is still an address problem rather than a generic failure.
    if (error.status === 422) return "auth.errors.invalidEmail";
    return "common.somethingWentWrong";
  }
  return "auth.errors.network";
}
